import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import ConnectedMenu from '../connectedComponents/ConnectedMenu.js';
import { apis } from '../api/index.js';
import i18n from 'i18next';
import { formatDate, breadBack, changeListWidth } from '../utils';
import { setScrollTop, calcTableHeight, showMoreSearch } from '../utils';
import { getParams, breadItem, loadingOptionsHtml } from '../utils';
import throttle from 'lodash.throttle';
import TableEmpty from '../components/TableEmpty.js';
import { message, Breadcrumb, Icon, Form, Select } from 'antd';
import { Button, Input, Table, Modal } from 'antd';

import InstitutionAdd from './InstitutionAdd.js';
import ProjectManager from './ProjectManager.js';

const { Option } = Select;
const { confirm } = Modal;

class InstitutionManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listWidth: 'calc(87% - 8px)',
      institutionData: [],
      addModalVisible: false,
      institutionInfo: {},
      detailType: '',
      selectedRowKeys: [],
      searchLoading: true,
      tableHeight: 0,
      moreFilter: true,
      showMoreFilter: false,
      projectVisible: false,
    };

    this.userInfo = {};
    this.throttledInstitutionList = throttle(newState => {
      setScrollTop();
      this.getInstitutionList(newState);
    }, 1000);

    this.formResize = throttle(newState => {
      //页面大小改变，更新table高度
      const newHeight = calcTableHeight(205) || 0;
      const showMore = showMoreSearch();
      this.setState({ showMoreFilter: showMore, tableHeight: newHeight });
    }, 1000);
  }

  static propTypes = {
    user: PropTypes.object,
    history: PropTypes.object,
    form: PropTypes.object,
  };

  componentDidMount() {
    this.throttledInstitutionList();
    let _this = this;
    window.addEventListener('resize', () => _this.formResize());
    this.formResize();
  }

  getInstitutionList = newState => {
    const updatedState = Object.assign({}, this.state, newState);
    this.setState(updatedState);
    const post = {
      institutionName: updatedState.name,
      status: updatedState.status,
      sortBy: updatedState.sortBy,
      sort: updatedState.sort,
    };
    apis.institutionRecord(post).then(res => {
      this.setState({ searchLoading: false });
      if (res.code === '0') {
        this.setState({ institutionData: res.data });
      } else if (res.code === '1009') {
        message.error('请先登录');
        this.props.history.push('/login');
      } else {
        this.setState({ institutionData: [] });
      }
    });
  };

  getColumns = () => {
    const columns = [];
    columns.push(
      {
        title: i18n.t('institutionID'), //机构ID
        dataIndex: 'id',
        key: 'id',
        width: '7.5%',
      },
      {
        title: i18n.t('institution'), //机构名称
        dataIndex: 'institutionName',
        key: 'institutionName',
        width: '10%',
      },
      {
        title: i18n.t('status'), //状态
        dataIndex: 'status',
        key: 'status',
        width: '7.5%',
        render: value => <span>{parseInt(value) === 0 ? '停用' : '启用'}</span>,
      },
      {
        title: i18n.t('contactperson'), //联系人
        dataIndex: 'contactPerson',
        key: 'contactPerson',
        width: '10%',
      },
      {
        title: i18n.t('contactNo'), // 联系方式
        dataIndex: 'contactNo',
        key: 'contactNo',
        width: '10%',
      },
      {
        title: i18n.t('region'), // 所在区域
        dataIndex: '',
        key: 'area',
        width: '10%',
        render: record => <span>{this.getAreaDetail(record)}</span>,
      },
      {
        title: i18n.t('address'), // 详细地址
        dataIndex: 'address',
        key: 'address',
        width: '15%',
      },
      {
        title: i18n.t('operateTime'), //操作时间
        dataIndex: 'updateTime',
        key: 'updateTime',
        width: '15%',
        sorter: true,
        sortDirections: ['ascend', 'descend'],
        render: value => <span>{formatDate(value)}</span>,
      },
      {
        title: i18n.t('operation'), //操作
        dataIndex: '',
        key: 'operation',
        align: 'center',
        width: '15%',
        render: list => (
          <>
            <Button
              type="link"
              className="btn-viewdetail"
              onClick={this.showAddModal.bind(this, list, 'update')}
            >
              <Icon type="edit" theme="filled" />
              {i18n.t('edit')}
            </Button>
            <Button
              type="link"
              className="btn-detail"
              onClick={this.showAddModal.bind(this, list, 'detail')}
            >
              <Icon type="eye" theme="filled" />
              {i18n.t('detail')}
            </Button>
          </>
        ),
      }
    );
    return columns;
  };

  getAreaDetail = record => {
    const detail = [];
    if (record.areaCountryDetail)
      detail.push(record.areaCountryDetail.areaName);
    if (record.areaProvinceDetail)
      detail.push(record.areaProvinceDetail.areaName);
    if (record.areaCityDetail) detail.push(record.areaCityDetail.areaName);
    if (record.areaDistrictDetail)
      detail.push(record.areaDistrictDetail.areaName);
    return detail.join('-');
  };

  showDeleteConfirm = () => {
    const { selectedRowKeys } = this.state;
    const _this = this;
    confirm({
      title: '删除',
      content: '已选中1条数据，确定删除所选数据吗？',
      okText: '删除',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        apis.deleteinstitution(selectedRowKeys.join(',')).then(res => {
          if (res.code === '0') {
            message.success('删除成功');
            _this.throttledInstitutionList();
          }
        });
      },
    });
  };

  showAddModal = (info, type) => {
    this.setState({
      addModalVisible: true,
      institutionInfo: info,
      detailType: type,
    });
  };

  hideAddModal = changed => {
    const state = { addModalVisible: false };
    if (changed) this.throttledInstitutionList(state);
    else this.setState(state);
  };

  handleSearch = e => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        const newState = {
          name: values.name,
          status: values.status,
          searchLoading: true,
        };
        this.throttledInstitutionList(newState);
      }
    });
  };

  //点击重置按钮
  handleReset = () => {
    this.props.form.resetFields();
  };

  //导出
  exportList = () => {
    const { name, status } = this.state;
    const post = { institutionName: name, status: status };
    const search = getParams(post);
    let url = '/ai-web/fromDr/exportInstitution?' + search;
    window.open(url);
  };

  toggleProjectVisible = () => {
    const { projectVisible } = this.state;
    this.setState({ projectVisible: !projectVisible });
  };
  setBackEvent = () => {
    // this.setSearchEvent('ns-066');
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    const { institutionData } = this.state;
    const { tableHeight, moreFilter, showMoreFilter } = this.state;
    const columns = this.getColumns();

    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({ selectedRowKeys });
      },
      type: 'radio',
    };

    const loadingOptions = loadingOptionsHtml(this.state.searchLoading);

    return (
      <div className="form-bg">
        <ConnectedMenu toggleCollapsed={() => changeListWidth(this)} />
        <div className="theme-content">
          <ConnectedHeader
            toggleCollapsed={() => changeListWidth(this)}
            login={false}
            home={true}
          />

          <div className="theme-box">
            <div className="bread-crumb">
              <Breadcrumb>{breadItem(['系统管理', '机构管理'])}</Breadcrumb>
              {breadBack(this)}
            </div>

            <div
              className="box theme-InstitutionManager"
              style={{ width: this.state.listWidth }}
            >
              <div className="left">
                <Form
                  className={`ant-advanced-search-form${
                    !moreFilter && showMoreFilter ? ' notOverflow' : ''
                  }`}
                  onSubmit={this.handleSearch}
                  layout="inline"
                >
                  <div className="searchBox">
                    <div className="searchBoxContent">
                      <Form.Item label="机构" colon={false}>
                        {getFieldDecorator('name', {})(
                          <Input
                            allowClear={true}
                            placeholder="请输入机构名称"
                            style={{ width: 240 }}
                          />
                        )}
                      </Form.Item>
                      <Form.Item label="状态" colon={false}>
                        {getFieldDecorator('status', {})(
                          <Select
                            placeholder="全部"
                            allowClear={true}
                            style={{ width: 160 }}
                          >
                            <Option value="1">启用</Option>
                            <Option value="0">关闭</Option>
                          </Select>
                        )}
                      </Form.Item>
                    </div>
                  </div>
                  <div className="searchOptBox">
                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="btn-search"
                      >
                        {this.state.loadingIconShow ? (
                          <Icon type="sync" spin />
                        ) : (
                          <Icon type="search" />
                        )}
                        搜索
                      </Button>
                      <Button
                        icon="redo"
                        style={{ marginLeft: 8 }}
                        className="btn-reset"
                        onClick={this.handleReset}
                      >
                        重置
                      </Button>
                      <Button
                        className="btn-m-plus"
                        onClick={this.showAddModal}
                      >
                        <Icon type="plus" />
                        新增
                      </Button>
                      <Button
                        className="btn-m-delete"
                        disabled={this.state.selectedRowKeys.length === 0}
                        onClick={this.showDeleteConfirm}
                      >
                        <Icon type="delete" />
                        删除
                      </Button>
                      <Button
                        className="btn-m-plus"
                        onClick={this.exportList}
                        icon="export"
                      >
                        导出
                      </Button>
                      <Button icon="hdd" onClick={this.toggleProjectVisible}>
                        项目管理
                      </Button>
                    </Form.Item>
                    {showMoreFilter && (
                      <Button
                        type="link"
                        className="moreFilter"
                        onClick={() =>
                          this.setState({ moreFilter: !moreFilter })
                        }
                        icon={moreFilter ? 'down' : 'up'}
                      >
                        {moreFilter ? '展开' : '收起'}
                      </Button>
                    )}
                  </div>
                </Form>
                <div className="history-list">
                  <Table
                    loading={loadingOptions}
                    rowSelection={rowSelection}
                    columns={columns}
                    dataSource={institutionData}
                    rowKey={record => record.id}
                    key={record => record.id}
                    className="list-item"
                    scroll={{ x: 1200, y: tableHeight }}
                    locale={{ emptyText: <TableEmpty /> }}
                    pagination={{
                      size: 'small',
                      pageSize: 20,
                      showTotal: () => `共${institutionData.length}条`,
                    }}
                    onChange={(pagination, filters, sorter) => {
                      const orderType = { descend: 'DESC', ascend: 'ASC' };
                      const sortType = orderType[sorter.order];
                      const orderField = sorter.columnKey || '';
                      const newState = {
                        page: 1,
                        sortBy: orderField,
                        sort: sortType,
                        searchLoading: true,
                      };
                      this.throttledInstitutionList(newState);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <InstitutionAdd
          visible={this.state.addModalVisible}
          userId={this.state.userId}
          onCancel={this.hideAddModal}
          institutionInfo={this.state.institutionInfo}
          detailType={this.state.detailType}
          institutionData={this.state.institutionData}
        />
        <ProjectManager
          visible={this.state.projectVisible}
          toggleProjectVisible={this.toggleProjectVisible}
        />
      </div>
    );
  }
}

export default withRouter(Form.create()(InstitutionManager));
